/*------------------*\
     MAIN SCRIPTS
\*------------------*/

// Ready
function ready(fn) {
  if (document.readyState !== "loading") {
    fn();
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

// Submit contact form
function submitContactForm(event) {
  event.preventDefault();

  // Disable the Submit Button
  event.target.textContent = "Submitting";
  event.target.disabled = true;

  // Check if valid email
  const isEmail = (email) => !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  // Strip special characters
  const stripSpecialChars = (string) =>
    string.replace(/[~"#%&*:<>?\/\\{}|]/g, "");

  // Form errors
  const errorMsgs = {
    required: "This field is required.",
    email: "Please enter a valid email address.",
  };
  let formErrors = 0;

  // Insert form error
  const insertError = (formElement, errorMsg) => {
    formErrors++;
    const p = document.createElement("p");
    p.classList.add("error");
    p.innerText = errorMsg;
    formElement.insertAdjacentElement("afterend", p);
  };

  // Clear existing form errors
  const currentErrors = document.querySelectorAll("#formContact .error");
  if (currentErrors) {
    currentErrors.forEach((error) => {
      error.remove();
    });
  }

  // Form data
  const nameInput = document.querySelector("#formContact #name");
  const nameValue = nameInput.value
    ? stripSpecialChars(nameInput.value.trim())
    : undefined;
  const emailInput = document.querySelector("#formContact #email");
  const emailValue = emailInput.value
    ? emailInput.value.toLowerCase().trim()
    : undefined;
  const msgInput = document.querySelector("#formContact #msg");
  const msgValue = msgInput.value
    ? stripSpecialChars(msgInput.value.trim())
    : undefined;

  // Validate name field
  if (nameValue === undefined) {
    insertError(nameInput, errorMsgs.required);
  }

  // Validate email field
  if (emailValue === undefined) {
    insertError(emailInput, errorMsgs.required);
  } else if (isEmail(emailValue)) {
    insertError(emailInput, errorMsgs.email);
  }

  // Validate msg field
  if (msgValue === undefined) {
    insertError(msgInput, errorMsgs.required);
  }

  if (formErrors === 0) {
    grecaptcha.ready(function () {
      grecaptcha
        .execute("6LfCVYsqAAAAAIZ49RMGm1_8uHg00nfSOxK7Fv5S", {
          action: "submit",
        })
        .then(async function (token) {
          await fetch("https://submit-form.com/wQX2xyOTX", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              name: nameValue,
              email: emailValue,
              msg: msgValue,
              "g-recaptcha-response": token,
            }),
          })
            .then(function (response) {
              window.location.href = `/contact/success`;
            })
            .catch(function (error) {
              // TODO: Log form errors…
              // console.error(error);
              window.location.href = "/contact/form-error";
            });
        });
    });
  } else {
    // Enable the Submit Button
    event.target.textContent = "Send";
    event.target.disabled = false;
  }
}

// Init
const init = async () => {
  // Contact form submit
  const contactFormSubmit = document.querySelector("#formContact #submit");
  if (contactFormSubmit) {
    // Attach event listener
    contactFormSubmit.addEventListener("click", submitContactForm);
  }
};

// Initialise on Document Ready
ready(init);
